<template>
  <transition name="sv-slide">
    <div v-if="visible" class="axr-overlay" @click.self="$emit('close')">
      <div class="axr-panel">
        <!-- Header -->
        <div class="axr-panel__header">
          <div class="axr-panel__title">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <rect
                x="3"
                y="4"
                width="18"
                height="18"
                rx="2"
                stroke="#0284C7"
                stroke-width="2"
                fill="none"
              />
              <line
                x1="3"
                y1="9"
                x2="21"
                y2="9"
                stroke="#0284C7"
                stroke-width="2"
              />
              <line
                x1="8"
                y1="2"
                x2="8"
                y2="6"
                stroke="#0284C7"
                stroke-width="2"
                stroke-linecap="round"
              />
              <line
                x1="16"
                y1="2"
                x2="16"
                y2="6"
                stroke="#0284C7"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            Reglas de retención
          </div>
          <span class="axr-panel__cam">{{ recorderIdentifier }}</span>
          <button class="axr-panel__close" @click="$emit('close')">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <line
                x1="18"
                y1="6"
                x2="6"
                y2="18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
              <line
                x1="6"
                y1="6"
                x2="18"
                y2="18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>

        <!-- Body -->
        <div class="axr-panel__body" v-loading="loading">
          <!-- Reglas existentes -->
          <div v-if="localRules.length > 0" class="axr-rules">
            <div
              v-for="rule in localRules"
              :key="rule.streamingEventId"
              class="axr-rule"
            >
              <el-switch
                v-model="rule.isActive"
                :disabled="editingId !== rule.streamingEventId"
              />
              <span class="axr-rule__event">{{ rule.streamingEventId }}</span>
              <el-input-number
                v-model="rule.daysToKeep"
                :min="1"
                :max="999"
                size="mini"
                class="axr-rule__days"
                :disabled="editingId !== rule.streamingEventId"
              />
              <span class="axr-rule__days-label">días</span>

              <button
                class="axr-btn axr-btn--small"
                :class="
                  editingId === rule.streamingEventId
                    ? 'axr-btn--primary'
                    : 'axr-btn--secondary'
                "
                :disabled="savingId === rule.streamingEventId"
                @click="onToggleEdit(rule)"
              >
                <template v-if="editingId === rule.streamingEventId">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
                    <polyline
                      points="20,6 9,17 4,12"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      fill="none"
                    />
                  </svg>
                  Guardar
                </template>
                <template v-else>
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      fill="none"
                    />
                    <path
                      d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      fill="none"
                    />
                  </svg>
                  Editar
                </template>
              </button>

              <button
                class="axr-rule__delete"
                title="Eliminar regla"
                :disabled="savingId === rule.streamingEventId"
                @click="onDelete(rule)"
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                  <polyline
                    points="3,6 5,6 21,6"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M19 6l-1 14H6L5 6"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M10 11v6M14 11v6"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M9 6V4h6v2"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div v-else-if="!loading" class="axr-empty">
            No hay reglas configuradas para esta cámara.
          </div>

          <!-- Nueva regla -->
          <div class="axr-new">
            <div class="axr-new__title">Nueva regla</div>
            <div class="axr-new__row">
              <el-select
                v-model="newRule.streamingEventId"
                placeholder="Evento"
                size="small"
                class="axr-new__select"
              >
                <el-option
                  v-for="ev in availableEventsForNew"
                  :key="ev.id"
                  :label="ev.name || ev.id"
                  :value="ev.id"
                />
              </el-select>
              <el-input-number
                v-model="newRule.daysToKeep"
                :min="1"
                :max="999"
                size="small"
                class="axr-new__days"
              />
              <span class="axr-rule__days-label">días</span>
              <button
                class="axr-btn axr-btn--primary"
                :disabled="!newRule.streamingEventId || creating"
                @click="onCreate"
              >
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
                  <line
                    x1="12"
                    y1="5"
                    x2="12"
                    y2="19"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <line
                    x1="5"
                    y1="12"
                    x2="19"
                    y2="12"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
                Añadir
              </button>
            </div>
            <div
              v-if="
                availableEventsForNew.length === 0 && availableEvents.length > 0
              "
              class="axr-new__hint"
            >
              Ya existe una regla para todos los eventos disponibles en esta
              cámara.
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="axr-panel__footer">
          <button class="axr-btn axr-btn--secondary" @click="$emit('close')">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  loadRetentionRules,
  createRetentionRule,
  deleteRetentionRule,
  updateRetentionDays,
  updateRetentionActive,
} from "@/services/axis.api";
import { getStreamingEvents } from "@/services/streamingEvent.api";

export default {
  name: "AxisRetentionDialog",
  props: {
    visible: { type: Boolean, default: false },
    recorderIdentifier: { type: String, required: true },
  },
  data() {
    return {
      localRules: [],
      availableEvents: [],
      loading: false,
      editingId: null,
      savingId: null,
      creating: false,
      newRule: { streamingEventId: "", daysToKeep: 30 },
    };
  },
  computed: {
    availableEventsForNew() {
      const usedEvents = this.localRules.map((r) => r.streamingEventId);
      return this.availableEvents.filter((ev) => !usedEvents.includes(ev.id));
    },
  },
  watch: {
    visible(val) {
      if (val) this.loadData();
    },
  },
  methods: {
    async loadData() {
      this.loading = true;
      this.editingId = null;

      try {
        const allRules = await loadRetentionRules();
        this.localRules = allRules
          .filter((r) => r.recorderIdentifier === this.recorderIdentifier)
          .map((r) => ({ ...r }));
      } catch (e) {
        console.error("Error cargando reglas de retención:", e);
        this.$message.error("Error al cargar las reglas de retención.");
      }

      try {
        this.availableEvents = await getStreamingEvents();
      } catch (e) {
        console.error("Error cargando eventos disponibles:", e);
        this.$message.error("Error al cargar los eventos disponibles.");
      }

      this.loading = false;
    },
    onToggleEdit(rule) {
      if (this.editingId === rule.streamingEventId) {
        this.onSave(rule);
      } else {
        this.editingId = rule.streamingEventId;
      }
    },
    async onSave(rule) {
      this.savingId = rule.streamingEventId;
      try {
        await Promise.all([
          updateRetentionDays(
            rule.recorderIdentifier,
            rule.streamingEventId,
            rule.daysToKeep
          ),
          updateRetentionActive(
            rule.recorderIdentifier,
            rule.streamingEventId,
            rule.isActive
          ),
        ]);
        this.$message.success(`Regla "${rule.streamingEventId}" guardada.`);
        this.editingId = null;
      } catch (e) {
        console.error("Error guardando regla:", e);
        this.$message.error("Error al guardar la regla.");
      } finally {
        this.savingId = null;
      }
    },
    async onDelete(rule) {
      try {
        await this.$confirm(
          `¿Eliminar la regla "${rule.streamingEventId}" para ${rule.recorderIdentifier}?`,
          "Confirmar",
          {
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar",
            type: "warning",
          }
        );
      } catch {
        return;
      }
      this.savingId = rule.streamingEventId;
      try {
        await deleteRetentionRule(
          rule.recorderIdentifier,
          rule.streamingEventId
        );
        this.localRules = this.localRules.filter(
          (r) => r.streamingEventId !== rule.streamingEventId
        );
        if (this.editingId === rule.streamingEventId) this.editingId = null;
        this.$message.success("Regla eliminada.");
      } catch (e) {
        console.error("Error eliminando regla:", e);
        this.$message.error("Error al eliminar la regla.");
      } finally {
        this.savingId = null;
      }
    },
    async onCreate() {
      this.creating = true;
      try {
        await createRetentionRule({
          recorderIdentifier: this.recorderIdentifier,
          streamingEventId: this.newRule.streamingEventId,
          daysToKeep: this.newRule.daysToKeep,
          isActive: true,
        });
        this.localRules.push({
          recorderIdentifier: this.recorderIdentifier,
          streamingEventId: this.newRule.streamingEventId,
          daysToKeep: this.newRule.daysToKeep,
          isActive: true,
        });
        this.newRule = { streamingEventId: "", daysToKeep: 30 };
        this.$message.success("Regla creada.");
      } catch (e) {
        console.error("Error creando regla:", e);
        if (e.response && e.response.status === 409) {
          this.$message.error(
            "Ya existe una regla para esta cámara y este evento."
          );
        } else {
          this.$message.error("Error al crear la regla.");
        }
      } finally {
        this.creating = false;
      }
    },
  },
};
</script>

<style>
.axr-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
}

.axr-panel {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  width: 680px;
  max-width: 92vw;
  display: flex;
  flex-direction: column;
  animation: axrSlideUp 0.2s ease;
  max-height: 85vh;
}

@keyframes axrSlideUp {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.axr-panel__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 12px 12px 0 0;
  flex-shrink: 0;
}

.axr-panel__title {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  flex: 1;
}

.axr-panel__cam {
  font-size: 12px;
  color: #0284c7;
  font-weight: 600;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  padding: 2px 8px;
}

.axr-panel__close {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  transition: border-color 0.15s, color 0.15s;
}
.axr-panel__close:hover {
  border-color: #94a3b8;
  color: #0f172a;
}

.axr-panel__body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.axr-rules {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.axr-rule {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px 14px;
}

.axr-rule__event {
  flex: 1;
  font-size: 13px;
  font-weight: 500;
  color: #0f172a;
}

.axr-rule__days {
  width: 100px !important;
}

.axr-rule__days-label {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
}

.axr-rule__delete {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid #fca5a5;
  background: #fef2f2;
  color: #ef4444;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
  flex-shrink: 0;
}
.axr-rule__delete:hover:not(:disabled) {
  background: #fee2e2;
}
.axr-rule__delete:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.axr-empty {
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
  padding: 20px 0;
}

.axr-new {
  border-top: 1px solid #e2e8f0;
  padding-top: 16px;
}

.axr-new__title {
  font-size: 11px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 10px;
}

.axr-new__row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.axr-new__select {
  width: 200px;
}

.axr-new__days {
  width: 110px !important;
}

.axr-new__hint {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 8px;
  font-style: italic;
}

.axr-panel__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 20px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 0 0 12px 12px;
  flex-shrink: 0;
}

.axr-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  padding: 7px 16px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}
.axr-btn--small {
  padding: 5px 11px;
  font-size: 11px;
}
.axr-btn--primary {
  background: #0284c7;
  color: #fff;
  border: none;
  box-shadow: 0 2px 6px rgba(2, 132, 199, 0.3);
}
.axr-btn--primary:hover:not(:disabled) {
  background: #0369a1;
}
.axr-btn--primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.axr-btn--secondary {
  background: #f8fafc;
  color: #64748b;
  border: 1px solid #e2e8f0;
}
.axr-btn--secondary:hover:not(:disabled) {
  border-color: #94a3b8;
  color: #475569;
}
</style>
